export default function Products() {
  const products = [
    {
      name: 'VPN',
      icon: 'ri-shield-check-line',
      gradient: 'from-[#1e3a8a] to-[#7c3aed]',
      features: [
        'Secure encrypted connections for complete privacy',
        'Fast servers worldwide with unlimited bandwidth',
        'Easy one-tap connection with automatic protection'
      ]
    },
    {
      name: 'Cleaner',
      icon: 'ri-brush-line',
      gradient: 'from-[#0f766e] to-[#0ea5e9]',
      features: [
        'Intelligent storage optimization and cleanup',
        'Remove duplicate photos and unnecessary files',
        'Boost device performance with smart algorithms'
      ]
    }
  ];

  return (
    <section className="bg-white py-[200px]" data-product-shop>
      <div className="px-[120px]">
        <h2 className="text-[56px] font-bold text-center text-[#1C1C1E] mb-[120px]">
          Our Products
        </h2>

        <div className="flex justify-center gap-[60px]">
          {products.map((product, index) => (
            <div
              key={product.name}
              className={`w-[520px] h-[680px] rounded-3xl bg-gradient-to-br ${product.gradient} p-12 shadow-2xl transform transition-all duration-300 hover:scale-105 hover:shadow-3xl cursor-pointer ${
                index === 0 ? '-rotate-2' : 'rotate-2'
              }`}
            >
              <div className="flex flex-col items-center h-full">
                {/* Icon */}
                <div className="flex items-center justify-center w-[120px] h-[120px] mb-8">
                  <i className={`${product.icon} text-white text-[120px]`}></i>
                </div>

                {/* Product name */}
                <h3 className="text-4xl font-bold text-white mb-12 text-center">
                  {product.name}
                </h3>

                {/* Features */}
                <div className="space-y-9 flex-1">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-4">
                      <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-lg font-light text-white leading-9">
                        {feature}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}